import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./custom-portfolio-config-form.i18n";

type CustomPortfolioConfigFormProps = {
  flowLanguage: string;
  showIsin: boolean;
  onShowIsinChange: (show: boolean) => void;
  showProductType: boolean;
  onShowProductTypeChange: (show: boolean) => void;
};

export function CustomPortfolioConfigForm({
  flowLanguage,
  showIsin,
  onShowIsinChange,
  showProductType,
  onShowProductTypeChange,
}: CustomPortfolioConfigFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/30">
      <div>
        <Label className="text-base">{t.fields}</Label>
        <p className="text-xs text-muted-foreground mt-1">{t.fieldsDesc}</p>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="add-show-isin">{t.isin}</Label>
            <p className="text-xs text-muted-foreground">{t.isinDesc}</p>
          </div>
          <Switch id="add-show-isin" checked={showIsin} onCheckedChange={onShowIsinChange} />
        </div>
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="add-show-product-type">{t.productType}</Label>
            <p className="text-xs text-muted-foreground">{t.productTypeDesc}</p>
          </div>
          <Switch
            id="add-show-product-type"
            checked={showProductType}
            onCheckedChange={onShowProductTypeChange}
          />
        </div>
      </div>
    </div>
  );
}
